import {useCallback} from 'react';
import {useQueryClient} from './react-query';

export function useUpdateQueryCache<TData>({key}: {key: string}) {
  const queryClient = useQueryClient();

  const updateCache = useCallback(
    (state: TData | ((oldData: TData | undefined) => TData)) => {
      return queryClient.setQueryData<TData>(key, state);
    },
    [key, queryClient],
  );

  return {
    updateCache,
    queryClient,
  };
}
